import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Import Images
import bg1 from '../../images/background/line-bg1.png';
import ptImg1 from '../../images/shap/circle-orange.png';
import ptImg2 from '../../images/shap/plus-orange.png';
import ptImg3 from '../../images/shap/circle-dots.png';

class aboutSection extends Component{
	render(){
		return(
			<>
				
				<section className="section-area section-sp5 work-area" style={{backgroundImage: "url("+bg1+")", backgroundRepeat:" no-repeat", backgroundPosition: "center", backgroundSize: "100%"}}>
					<div className="container-sm">
						<div className="heading-bx text-center">
							<h6 className="title-ext text-secondary">Nuestro mantra</h6>
							<h2 className="title">Cómo funciona?</h2>
						</div>
						<div className="row justify-content-center">
							<div className="col-lg-4 col-sm-6 mb-30">
								
								<div className="work-bx active">
									<div className="work-num-bx">01</div>
									<div className="work-content">
										<h5 className="title mb-10">Conocernos</h5>
										<p>Lo primero es que vengas a visitarnos puedes agendar un turno a través de whatsapp o a través de Uto, nuestro asistente virtual.</p>
									</div>
									<a href="https://wa.me/5491137774576?text=Hola,%20me%20gustaría%20agendar%20un%20turno" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Agendar Turno <i className="btn-icon-bx fas fa-chevron-right"></i></a>
								</div>
							</div>
							<div className="col-lg-4 col-sm-6 mb-30">
								<div className="work-bx active">
									<div className="work-num-bx">02</div>
									<div className="work-content">
										<h5 className="title mb-10">Diagnóstico</h5>
										<p>El diagnóstico es la base fundamental de un tratamiento adecuado, nos permitira planificar y personalizar tu tratamiento en base a tus necesidades</p>
									</div>
									{/* <Link to="/services" className="btn btn-primary light">View More <i className="btn-icon-bx fas fa-chevron-right"></i></Link> */}
								</div>
							</div>
							<div className="col-lg-4 col-sm-6 mb-30">
								<div className="work-bx">
									<div className="work-num-bx">03</div>
									<div className="work-content">
										<h5 className="title  mb-10">Tratamiento</h5>
										<p>Una vez planifiquemos de acuerdo a tu diagnóstico empezaremos a darte un tratamiento personalizado</p>
									</div>
									{/* <Link to="/contact-us" className="btn btn-primary light">View More <i className="btn-icon-bx fas fa-chevron-right"></i></Link> */}
								</div>
							</div>
						</div>
					</div>
					<img className="pt-img1 animate1" src={ptImg1} alt=""/>
					<img className="pt-img2 animate2" src={ptImg2} alt=""/>
					<img className="pt-img3 animate3" src={ptImg3} alt=""/>
				</section>
				
			</>
		);
	}
}

export default aboutSection;